import { useRouteQuery, type RouteQueryOptions } from "../api/route-query.ts";

/*
 * The customer's own data (07 §2.2, UC-25, UC-21). Thin names over the route catalogue; the
 * page decides what to show, the API what to send.
 */

/**
 * `GET /api/products`: the catalogue, with `actions` when signed in (ADR-075). `enabled` keeps it
 * idle where a guest may not read it (the guest view off, ADR-133 point 3).
 */
export const useProducts = (options: RouteQueryOptions = {}) => useRouteQuery("products", {}, options);

/** `GET /api/customer`: status, credit limit, instance. */
export const useCustomer = () => useRouteQuery("customer");

/** `GET /api/customer/users`: users and roles, for the administrator (`user.view`, ADR-074). */
export const useCustomerUsers = () => useRouteQuery("customerUsers");
